import React, { useEffect } from "react";
import ChatSection from "../chat/ChatSection";
import useChatNotifications from "../../hooks/useChatNotifications";

const AdminChat = () => {
  const { markAsSeen } = useChatNotifications("admin");

  useEffect(() => {
    markAsSeen();
    const timer = setInterval(() => markAsSeen(), 5000);
    return () => clearInterval(timer);
  }, [markAsSeen]);

  return <ChatSection mode="admin" />;
};

export default AdminChat;
